import { Item } from "@choc-ui/chakra-autocomplete";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type Actions = {
  setFormData: (data: Partial<CustomSearchState>) => void;
  reset: () => void;
};

type CustomSearchState = {
  all?: string;
  title?: string;
  abstract?: string;
  authors: Array<string>;
  publicationVenues: Array<Item>;
  publicationTypes: Array<Item>;
  fieldsOfStudy: Array<Item>;
  minCitations?: number;
  minYear?: number;
  maxYear?: number;
  isOpenAccess?: boolean;
};

const initialState: CustomSearchState = {
  all: "",
  title: "",
  abstract: "",
  authors: [],
  publicationVenues: [],
  publicationTypes: [],
  fieldsOfStudy: [],
  minCitations: undefined,
  minYear: undefined,
  maxYear: undefined,
  isOpenAccess: false,
};

const useCustomSearchFilters = create<CustomSearchState & Actions>()(
  persist(
    (set, get) => ({
      ...initialState,
      setFormData: (data: Partial<CustomSearchState>) => {
        const currentState = get();
        set({
          ...currentState,
          ...data,
        });
      },
      reset: () => set(initialState),
    }),
    {
      name: "custom-search-filters",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        all: state.all,
        title: state.title,
        abstract: state.abstract,
        authors: state.authors,
        publicationVenues: state.publicationVenues,
        publicationTypes: state.publicationTypes,
        fieldsOfStudy: state.fieldsOfStudy,
        minCitations: state.minCitations,
        minYear: state.minYear,
        maxYear: state.maxYear,
        isOpenAccess: state.isOpenAccess,
      }),
    }
  )
);

export default useCustomSearchFilters;
export type { CustomSearchState };
